import { helper } from '@ember/component/helper';
import { ActionType } from 'cio/models/action';
import { Measure } from 'cio/utils/metrics/common';
import { isDeliveryMeasureEnabledForActionType } from 'cio/utils/metrics/measure';

export function isDeliveryMeasureEnabledForActionTypeHelper([measure, actionType]: [Measure, ActionType]) {
  return isDeliveryMeasureEnabledForActionType(measure, actionType);
}

export default helper(isDeliveryMeasureEnabledForActionTypeHelper);
